export default "/_next/static/chunks/fonts/icons-3e8b34b1abeeae7e1e418d87e1bba5dd.ttf";